
import { Image } from "utils"

const background = `

//ignoring (or not even declaring) this variable crashes PIXI:
varying vec2 vTextureCoord;
//comments at uniform section are NOT working when it's under PIXI ...

uniform vec3 color;

void main()
{
    gl_FragColor.rgb = color + vTextureCoord.x * 0.0001;
    gl_FragColor.a = 1.0;
}
`

export let ear_url = 'res/common/ears/left_ear_0.png'

export default function( space, container )
{
    /*//any image just needed to make PIXI work - couldn't run shader without any textures:
    let whatever
    for ( let i in PIXI.utils.TextureCache ) {
        if ( i.indexOf( '.json' ) >= 0 ) continue
        whatever = i
        break
    }
    console.log( 'taking', whatever, 'as a cloth' )
    const cloth = Image( whatever )

    const color = [ 0.00392156862, 0.10588235294, 0.13333333333 ]
    
    const shader = new PIXI.Filter(
        null,
        background,
        {
            color,
        }
    )
    shader.uniforms.color = color
    space.s( "change_screen" ).on( size => {
        if (cloth) {
            cloth.width = size.w
            cloth.height = size.h
        }
    } )
    
    cloth.filters = [ shader ]
    container.addChild( cloth )*/

    const left_ear = Image( ear_url )
    container.addChild( left_ear )
    const right_ear = Image( ear_url )
    container.addChild( right_ear )

    //resize and reposition ears:
    space.s( 'resize' )
        .with( space.s( 'change_screen' ), ( size, screen ) => ({ size, screen }) )
        .on( ({ size, screen }) => {
            const ear_w = ( screen.w - size.x ) / 2

            //adding another ear_w because of flipping image with scale.x = -1:
            right_ear.x = ear_w * 2 + size.x

            left_ear.y = right_ear.y = ( screen.h - size.y ) / 2

            left_ear.scale.x = ear_w / left_ear.texture.width
            right_ear.scale.x = left_ear.scale.x * -1

            left_ear.scale.y = right_ear.scale.y = size.y / left_ear.texture.height
        } )
}





// WEBPACK FOOTER //
// ./src/library/ears.es6